// Shared selector-matching logic used by both recorder.ts (rrweb mask/block/ignore
// config) and curated.ts (so curated click labels never leak masked/blocked text).

export interface SelectorConfig {
  mask: string[];
  block: string[];
  ignore: string[];
}

export function parseSelectorAttr(value: string | null | undefined): string[] {
  if (!value) return [];
  return value
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

function matchesAny(el: Element, selectors: string[]): boolean {
  for (const sel of selectors) {
    try {
      if (el.closest(sel)) return true;
    } catch {
      // invalid/unsupported selector from customer config -- skip it, don't throw.
    }
  }
  return false;
}

/** True if `el` or any ancestor matches one of the customer's mask or block selectors. */
export function isMaskedOrBlocked(el: Element | null, selectors: SelectorConfig): boolean {
  if (!el) return false;
  return matchesAny(el, selectors.mask) || matchesAny(el, selectors.block);
}
